import axios from "axios";

export default class SMS {
    _apiBase = '/ajax/fast-order/sms.php';

    getResource = async (params) => {
        return await axios.post(this._apiBase, params).then(value => {
            return value;
        }).catch(() => {
            return [];
        });
    };

    setPhoneSms = async (phone, orderId) => {
        return await this.getResource({
            "action": "set_phone_sms",
            "phone": phone,
            "order": orderId,
        });
    };

    sendAnotherCode = async (orderId) => {
        return await this.getResource({
            "action": "send_another_code",
            "order": orderId,
        });
    };


    checkConfirmationCode = async (code, orderId) => {
        return await this.getResource({
            "action": "check_confirmation_code",
            "code": code,
            "order": orderId,
        });
    };
}